import React from 'react'

import { string } from 'prop-types'

import UserTabs from './UserTabs'

function SignUpWrapper({
  activeTabId,
  customId,
  source,
}) {
  return (
    <div className="card">
      <UserTabs
        activeTabId={activeTabId}
        customId={customId}
        source={source}
        captchaId="navbar-captcha"
      />
    </div>
  )
}

SignUpWrapper.propTypes = {
  activeTabId: string,
  customId: string.isRequired,
  source: string,
}

export default SignUpWrapper
